function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5666 6.6132L15.7635 12.9575L11.9091 17.1321L7.25361 12.0613L6.45243 12.9575L0.822512 19.066C0.62763 19.2783 0.541016 19.5613 0.541016 19.8207C0.541016 20.1273 0.649283 20.4339 0.865819 20.6698C1.03905 20.882 1.27724 21 1.51543 21H20.4839C21.1335 21 21.6532 20.4339 21.6532 19.7264V6.51886L21.5883 6.6132H21.5666Z",
  fill: "currentColor",
  fillOpacity: 0.5
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6752 1.35377C21.2421 0.882076 20.5709 0.882076 20.1378 1.35377L11.7579 10.4811L7.38386 5.71697L0.324803 13.4056C-0.108268 13.8773 -0.108268 14.6085 0.324803 15.0802C0.541339 15.316 0.822835 15.4339 1.08268 15.4339C1.34252 15.4339 1.64567 15.316 1.84055 15.0802L7.38386 9.04244L11.7579 13.8066L21.6752 3.00471C22.1083 2.53302 22.1083 1.80189 21.6752 1.33019V1.35377Z",
  fill: "currentColor"
});
function SvgMmmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmmIcon);
export default __webpack_public_path__ + "static/media/MMM_Icon.6993d4eed79cd105eb622f59f0f1f7e2.svg";
export { ForwardRef as ReactComponent };